import React, { Component } from 'react'
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Card, CardBody, Row, Col, Label, Button, Alert, CardHeader } from "reactstrap";
import { Textbox } from "react-inputs-validation";
import { urlModelosAutosRCA, urlConsultarCedula } from '../../constants/urls'
import { apiGet } from '../../api/index'
import { vehiculoConst } from '../../constants'
import Select1 from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import { formatoReactSelect } from '../../redux/selectors/varios'

export default class DatosVehiculo extends Component {

    constructor(props) {
        super(props)

        const { datosProducto: dataVehi, datosCliente = {}, placa } = this.props
        const { cedulaConductor = '', nombreConductor = '' } = datosCliente
        let hasModeloError = true
        let hasColorError = true
        let hasProcedenciaError = true
        let datosVehiculo = dataVehi ? { ...dataVehi } : vehiculoConst
        if (datosVehiculo && (`${datosVehiculo.modeloCodigo}` !== '-1' || `${datosVehiculo.modeloCodigo}` !== '')) hasModeloError = false
        if (datosVehiculo && (`${datosVehiculo.colorCodigo}` !== '' || `${datosVehiculo.colorNombre}` !== '')) hasColorError = false
        if (datosVehiculo && (`${datosVehiculo.procedenciaCodigo}` !== '' || `${datosVehiculo.procedenciaNombre}` !== '')) hasProcedenciaError = false

        console.log(datosVehiculo)

        this.state = {
            validate: false, loading: false,
            cedulaConductor,
            nombreConductor,
            modelos: [],
            datosVehiculo: { ...datosVehiculo, placa },
            hasAnioError: datosVehiculo.anio ? false : true,
            hasCedulaError: true,
            hasChasisError: datosVehiculo.chasis ? false : true,
            hasMarcaError: datosVehiculo.marcaNombre ? false : true,
            hasModeloError,
            hasColorError,
            hasProcedenciaError,
            hasMotorError: datosVehiculo.motor ? false : true,
            hasNombreError: true,

        }
        console.log('ESTADO CONST')
    }
    componentDidMount() {
        const { marcaCodigo } = this.state.datosVehiculo
        const { modelos } = this.props

        if ((marcaCodigo && `${marcaCodigo}` !== '-1') && !modelos) {
            this.consultarModelos(marcaCodigo)
        } else if (modelos) this.setState({ modelos })
        setTimeout(() => this.toggleValidate(2000), 1000)

        window.scroll(0, 0)
    }

    consultaCargarDatos = async (cedulaConductor) => {
        const data = await apiGet(urlConsultarCedula + cedulaConductor)
        const { nombre = '', } = data

        this.setState({ loading: false, nombreConductor: nombre, validate: true })
        setTimeout(() => this.toggleValidate(false), 1000)

    }

    consultarModelos = async (id) => {
        const { transaccion, modelos } = await apiGet(urlModelosAutosRCA + id)
        console.log('data modelos', modelos)
        if (transaccion)
            this.setState({ modelos })
    }

    componentDidUpdate(prevProps, prevState) {
        const { datosProducto: datosVehiculo, datosManuales } = this.props
        if (datosManuales !== prevProps.datosManuales || datosVehiculo !== prevProps.datosProducto) {
            console.log('ESTADO CDU', this.props, prevProps, datosManuales, datosVehiculo, datosVehiculo !== prevProps.datosVehiculo)
            this.setState({ datosVehiculo, datosManuales })
        }
    }

    toggleValidate = (validate) => {
        this.setState({ validate })
    }

    onClick = () => {
        this.toggleValidate(true)
        console.log('ESTADO', this.state)

        const {
            hasAnioError,
            hasCedulaError,
            hasChasisError,
            hasColorError,
            hasMarcaError,
            hasModeloError,
            hasMotorError,
            hasNombreError,
            hasProcedenciaError } = this.state

        // console.log('ESTADO', (!hasAnioError &&
        //     !hasCedulaError &&
        //     !hasChasisError &&
        //     !hasColorError &&
        //     !hasMarcaError &&
        //     !hasModeloError &&
        //     !hasMotorError &&
        //     !hasNombreError &&
        //     !hasProcedenciaError))

        if (
            !hasAnioError &&
            !hasCedulaError &&
            !hasChasisError &&
            !hasColorError &&
            !hasMarcaError &&
            !hasModeloError &&
            !hasMotorError &&
            !hasNombreError 
            // && !hasProcedenciaError
        ) {

            let { cedulaConductor, datosVehiculo, nombreConductor, modelos } = this.state

            const paso = 2;

            const { colores, marcas, procedencia, categorias } = this.props

            if (datosVehiculo.marcaCodigo && !datosVehiculo.marcaNombre && `${datosVehiculo.marcaCodigo}` !== `-1`)
                datosVehiculo.marcaNombre = marcas.find(({ id }) => `${id}` === `${datosVehiculo.marcaCodigo}`).name

            if (datosVehiculo.modeloCodigo && !datosVehiculo.modeloNombre && `${datosVehiculo.modeloCodigo}` !== `-1`)
                datosVehiculo.modeloNombre = modelos.find(({ id }) => `${id}` === `${datosVehiculo.modeloCodigo}`).name

            if (datosVehiculo.colorCodigo && !datosVehiculo.colorNombre && `${datosVehiculo.colorCodigo}` !== `-1`)
                datosVehiculo.colorNombre = colores.find(({ id }) => `${id}` === `${datosVehiculo.colorCodigo}`).name

            if (datosVehiculo.procedenciaCodigo && !datosVehiculo.procedenciaNombre && `${datosVehiculo.procedenciaCodigo}` !== `-1`)
                datosVehiculo.procedenciaNombre = procedencia.find(({ id }) => `${id}` === `${datosVehiculo.procedenciaCodigo}`).name

            if (datosVehiculo.categoriaCodigo && !datosVehiculo.categoriaNombre && `${datosVehiculo.categoriaCodigo}` !== `-1`)
                datosVehiculo.categoriaNombre = categorias.find(({ id }) => `${id}` === `${datosVehiculo.categoriaCodigo}`).name

            let {checkPlaca,setMostrarError} =  this.props    
            if(checkPlaca){
                this.props.handleNext({ params: { cedulaConductor, datosVehiculo: [datosVehiculo], nombreConductor }, paso })
            }else{
                setMostrarError(true)
            }

        }
    }

    render() {
        let { colores, marcas = [], procedencia = [], categorias = [], datosManuales, rangoInf, rangoSup } = this.props
        const { validate, loading, cedulaConductor, nombreConductor, datosVehiculo, hasProcedenciaError, hasColorError } = this.state
        const {
            marcaCodigo,
            marcaNombre,
            modeloCodigo,
            modeloNombre,
            anio,
            // placa,
            motor,
            chasis,
            colorCodigo,
            // colorNombre,
            procedenciaCodigo,
            // procedenciaNombre,
            categoriaCodigo,
            categoriaNombre,
        } = datosVehiculo

        const prVehi = this.props.datosProducto

        console.log('PPPP', this.props)
        console.log('modelo', this.state)

        let { modelos = [], } = this.state

        marcas = formatoReactSelect(marcas, 'id', 'name')
        procedencia = formatoReactSelect(procedencia, 'id', 'name')
        categorias = formatoReactSelect(categorias, 'id', 'name')
        modelos = formatoReactSelect(modelos, 'id', 'name')

        if (colores && colores[0] && colores[0].id) colores.splice(0, 1)

        const defaulMarca = marcas.find(item => `${item.value}` === `${marcaCodigo}`)
        const defaulModelos = modelos.find(item => `${item.value}` === `${modeloCodigo}`)
        const defaulColor = colores.find(item => `${item.value}` === `${colorCodigo}`)
        const defaulProcedencia = procedencia.find(item => `${item.value}` === `${procedenciaCodigo}`)
        const defaulCategoria = categorias.find(item => `${item.value}` === `${categoriaCodigo}`)


        return (
            <LoadingScreen
                loading={loading}
                bgColor="#f1f1f1"
                spinnerColor="#001871"
                textColor="#676767"
                logoSrc={logo}
                text="Cargando..."
            >
                <div>
                    <Card>
                        <CardHeader> <h4 style={{ fontWeight: 'bold', }}> Datos del Conductor </h4></CardHeader>
                        <CardBody>
                            <Row>
                                <Col sm={4} >
                                    <h4 >Cédula/Ruc</h4>
                                </Col>
                                <Col sm={7} >
                                    <Textbox

                                        type="text"
                                        id={"cedula"}
                                        name="cedula"
                                        classNameInput={"form-control"}
                                        value={cedulaConductor}
                                        validate={validate}
                                        onChange={(cedulaConductor, e) => {
                                            this.setState({ cedulaConductor })
                                            if (cedulaConductor.length === 10) {
                                                this.setState({ loading: true })
                                                this.consultaCargarDatos(cedulaConductor)
                                            }
                                        }}
                                        onBlur={() => { }}
                                        validationCallback={res => this.setState({ hasCedulaError: res, validate: false })}
                                        validationOption={{
                                            name: "cedula", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            //reg: /^\d{10}$/,
                                            msgOnError: "Por favor ingrese la identificación del conductor"
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={4} >
                                    <h4 >Nombre</h4>
                                </Col>
                                <Col sm={7} >
                                    <Textbox

                                        type="text"
                                        id={"inNomConductor"}
                                        name="inNomConductor"
                                        classNameInput={"form-control"}
                                        value={nombreConductor}
                                        validate={validate}
                                        onChange={(nombreConductor, e) => this.setState({ nombreConductor })}
                                        onBlur={() => { }}
                                        validationCallback={res => { console.log('Ingresa callback', res); this.setState({ hasNombreError: res, validate: false }) }}
                                        validationOption={{
                                            name: "inNomConductor", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor ingrese el nombre del conductor"
                                        }}
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    {/*********-------------Vehículo----------********/}

                    <Card>
                        <CardHeader> <h4 style={{ fontWeight: 'bold', }}> Datos del Vehículo </h4></CardHeader>
                        <CardBody>

                            < div style={{ display: (datosVehiculo.marcaEd || datosManuales) ? 'block' : 'none' }}>
                                <Row  >
                                    <Col sm={4}>
                                        <h4><Label for="selectMarca" >Marca </Label></h4>
                                    </Col>
                                    <Col sm={7}  >

                                        <Select1
                                            value={defaulMarca}
                                            //defaultValue={defaulGiro}
                                            components={makeAnimated()}
                                            onChange={({ label, value }, e) => {

                                                this.consultarModelos(value);
                                                this.setState({ datosVehiculo: { ...datosVehiculo, marcaCodigo: value, marcaNombre: `${value}` === '-1' ? '' : label }, hasMarcaError: value ? false : true })
                                            }}
                                            options={marcas}
                                            isSearchable={true}
                                            placeholder={"Seleccione una Marca"}
                                            isMulti={false}
                                        />

                                        {/* <Select
                                        id={"selectMarca"} // Optional.[String].Default: "". Input ID.
                                        name={"selectMarca"} // Optional.[String].Default: "". Input name.
                                        value={marcaCodigo} // Optional.[String].Default: "".
                                        optionList={marcas} // Required.[Array of Object(s)].Default: [].
                                        onChange={(marcaCodigo, e) => { this.consultarModelos(modeloCodigo); this.setState({ datosVehiculo: { ...datosVehiculo, marcaCodigo }, hasMarcaError: false }) }}
                                        validate={validate}
                                        validationCallback={(res) => { console.log('marca', res); this.setState({ hasMarcaError: res, validate: false }) }}
                                        // Optional.[Func].Default: () => {}. Will return the value.
                                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                        validationOption={{
                                            name: "selectMarca", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor seleccione una Marca"
                                        }}
                                    /> */}
                                    </Col>
                                </Row>
                            </div>

                            {((`${marcaCodigo}` === `-1`) || !(datosVehiculo.marcaEd || datosManuales)) &&
                                <Row >
                                    <Col sm={4}>
                                        <h4><Label for="marca" >Ingrese la Marca </Label></h4>
                                    </Col>
                                    <Col sm={7} ><Textbox
                                        //disabled={}

                                        type="text"
                                        id="textMarca"
                                        name="textMarca"
                                        classNameInput={((prVehi.marcaCodigo && prVehi.marcaNombre) && `${marcaCodigo}` !== '-1') ? "input-type-label form-control" : "form-control"}
                                        value={marcaNombre}
                                        validate={validate}
                                        onChange={(marcaNombre, e) => { console.log('ESTADO change marcas2'); this.setState({ datosVehiculo: { ...datosVehiculo, marcaNombre, } }) }}
                                        onBlur={() => { }}
                                        validationCallback={res => { console.log('ESTADO change marcas callback'); this.setState({ hasMarcaError: res, validate: false }) }}
                                        validationOption={{
                                            name: "textMarca", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor ingrese la Marca"
                                        }}
                                    />

                                    </Col>
                                </Row>
                            }
                            {((`${marcaCodigo}` !== `-1`) && (!prVehi.modeloCodigo || !prVehi.modeloNombre || datosVehiculo.modeloEd)) &&
                                <Row >
                                    <Col sm={4}>
                                        <h4><Label for="selectModelo" >Modelos </Label></h4>
                                    </Col>
                                    <Col sm={7} >
                                        <Select1
                                            value={defaulModelos}
                                            //defaultValue={defaulGiro}
                                            components={makeAnimated()}
                                            onChange={({ label, value, modCodTipoVehiculo: categoriaCodigo, modDescripcionTipoVehiculo: categoriaNombre }, e) => {
                                                console.log('ESTADO change');
                                                //": value, :

                                                this.setState({ datosVehiculo: { ...datosVehiculo, modeloCodigo: value, modeloNombre: `${value}` === `-1` ? '' : label, categoriaNombre, categoriaCodigo, categoriaEd: `${value}` === `-1` ? true : false }, hasModeloError: value ? false : true })
                                            }}
                                            options={modelos}
                                            isSearchable={true}
                                            placeholder={"Seleccione un Modelo"}
                                            isMulti={false}
                                        />
                                    </Col>
                                </Row>
                            }

                            {((`${modeloCodigo}` === `-1`) || (`${marcaCodigo}` === `-1`) || !datosVehiculo.modeloEd) &&
                                < Row >
                                    <Col sm={4}>
                                        <h4><Label for="selectModelo" >Modelo </Label></h4>
                                    </Col>
                                    <Col sm={7} >
                                        <Textbox
                                            type="text"
                                            id="textModelo"
                                            name="textModelo"
                                            classNameInput={((prVehi.modeloCodigo && prVehi.modeloNombre) && `${marcaCodigo}` !== '-1') && !datosVehiculo.modeloEd ? "input-type-label form-control" : "form-control"}
                                            style={{ marginTop: 10 }}
                                            value={modeloNombre}
                                            validate={validate}
                                            onChange={(modeloNombre, e) => this.setState({ datosVehiculo: { ...datosVehiculo, modeloNombre } })}
                                            onBlur={() => { }}
                                            validationCallback={res => this.setState({ hasModeloError: res, validate: false })}
                                            validationOption={{
                                                name: "textModelo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                msgOnError: "Por favor ingrese el Modelo"
                                            }}
                                        />


                                    </Col>
                                </Row>
                            }

                            <Row >
                                <Col sm={4} >
                                    <h4 >Motor</h4>
                                </Col>
                                <Col sm={7} >
                                    <Textbox

                                        type="text"
                                        id="inMotor"
                                        name="inMotor"
                                        classNameInput={(`${marcaCodigo}` === `-1` || datosManuales || datosVehiculo.motorEd) ? "form-control" : "input-type-label form-control"}

                                        value={motor}
                                        validate={validate}
                                        onChange={(motor, e) => this.setState({ datosVehiculo: { ...datosVehiculo, motor } })}
                                        onBlur={() => { }}
                                        validationCallback={res => this.setState({ hasMotorError: res, validate: false })}
                                        validationOption={{
                                            name: "inMotor", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor ingrese el numero de motor"
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row >
                                <Col sm={4} >
                                    <h4 >Chasis</h4>
                                </Col>
                                <Col sm={7} >
                                    <Textbox

                                        type="text"
                                        id="inChasis"
                                        name="inChasis"
                                        classNameInput={(`${marcaCodigo}` === `-1` || datosManuales || datosVehiculo.chasisEd) ? "form-control" : "input-type-label form-control"}
                                        value={chasis}
                                        validate={validate}
                                        onChange={(chasis, e) => this.setState({ datosVehiculo: { ...datosVehiculo, chasis } })}
                                        onBlur={() => { }}
                                        validationCallback={res => this.setState({ hasChasisError: res, validate: false })}
                                        validationOption={{
                                            name: "inChasis", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor ingrese el Chasis"
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row >
                                <Col sm={4} >
                                    <h4 >Año</h4>
                                </Col>
                                <Col sm={7} >
                                    <Textbox

                                        type="text"
                                        id="inYear"
                                        name="inYear"
                                        classNameInput={(`${marcaCodigo}` === `-1` || datosManuales || datosVehiculo.anioEd) ? "form-control" : "input-type-label form-control"}
                                        value={anio}
                                        validate={validate}
                                        onChange={(anio, e) => { this.setState({ datosVehiculo: { ...datosVehiculo, anio } }); setTimeout(() => this.setState({ validate: true }), 300) }}
                                        onBlur={() => { }}
                                        validationCallback={res => { this.setState({ hasAnioError: res, validate: false }) }}
                                        validationOption={{
                                            name: "inYear", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                            min: rangoInf, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                            max: rangoSup,
                                            msgOnError: `Por favor ingrese el año entre ${rangoInf} y ${rangoSup}`
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row >
                                <Col sm={4}>
                                    <h4><Label for="selectColor" >Color </Label></h4>
                                </Col>
                                <Col sm={7} >

                                    <Select1
                                        value={defaulColor}
                                        //defaultValue={defaulGiro}
                                        components={makeAnimated()}
                                        onChange={({ label, value }, e) => {
                                            this.setState({ datosVehiculo: { ...datosVehiculo, colorCodigo: value, colorNombre: label }, hasColorError: value ? false : true })
                                        }}
                                        options={colores}
                                        isSearchable={true}
                                        placeholder={"Seleccione un Color"}
                                        isMulti={false}
                                    />
                                    {hasColorError && <span style={{ color: '#FA5A77', fontSize: 14, }} >Seleccione un color</span>}

                                </Col>
                            </Row>

                            <Row style={{display:"none"}}>
                                <Col sm={4}>
                                    <h4><Label for="selecProcedencia" >Procedencia </Label></h4>
                                </Col>
                                <Col sm={7} >
                                    <Select1
                                        value={defaulProcedencia}
                                        //defaultValue={defaulGiro}
                                        components={makeAnimated()}
                                        onChange={({ label, value }, e) => {
                                            this.setState({ datosVehiculo: { ...datosVehiculo, procedenciaCodigo: value, procedenciaNombre: label }, hasProcedenciaError: value ? false : true })
                                        }}
                                        options={procedencia}
                                        isSearchable={true}
                                        placeholder={"Seleccione una procedencia"}
                                        isMulti={false}
                                    />
                                    {hasProcedenciaError && <span style={{ color: '#FA5A77', fontSize: 14, }} >Seleccione una procedencia </span>}
                                    {/* <Select
                                        tabIndex="9" // Optional.[String or Number].Default: none.
                                        id={"selecProcedencia"} // Optional.[String].Default: "". Input ID.
                                        name={"selecProcedencia"} // Optional.[String].Default: "". Input name.
                                        value={procedenciaCodigo} // Optional.[String].Default: "".
                                        optionList={procedencia} // Required.[Array of Object(s)].Default: [].
                                        onChange={(procedenciaCodigo, e) => this.setState({ datosVehiculo: { ...datosVehiculo, procedenciaCodigo } })}
                                        validate={validate}
                                        validationCallback={res => this.setState({ hasProcedenciaError: res, validate: true })}
                                        // Optional.[Func].Default: () => {}. Will return the value.
                                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                        validationOption={{
                                            name: "selecProcedencia", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor seleccione la procedencia del vehículo"
                                        }}
                                    /> */}
                                </Col>
                            </Row>

                            <Row >
                                <Col sm={4}>
                                    <h4><Label for="selecCategoria" >Categoría </Label></h4>
                                </Col>
                                {console.log('????', categoriaNombre, categoriaCodigo, modeloCodigo)}
                                <Col sm={7} >
                                    {((!categoriaNombre && !categoriaCodigo) || `${modeloCodigo}` == '-1' || datosVehiculo.categoriaEd) &&
                                        <Select1
                                            value={defaulCategoria}
                                            //defaultValue={defaulGiro}
                                            style={((prVehi.marcaCodigo && prVehi.marcaNombre) && `${marcaCodigo}` !== '-1') ? "input-type-label form-control" : "form-control"}
                                            components={makeAnimated()}
                                            onChange={({ label, value }, e) => {
                                                console.log('ESTADO change');
                                                this.setState({ datosVehiculo: { ...datosVehiculo, categoriaCodigo: value, categoriaNombre: label }, hasCategoriaError: value ? false : true })
                                            }}
                                            options={categorias}
                                            isSearchable={true}
                                            placeholder={"Seleccione una categoría"}
                                            isMulti={false}
                                        />}
                                    {((prVehi.categoriaNombre && prVehi.categoriaCodigo && `${prVehi.modeloCodigo}` != '-1') || (categoriaNombre && categoriaCodigo && `${modeloCodigo}` != '-1')) && !datosVehiculo.categoriaEd &&
                                        <Textbox
                                            type="text"
                                            id="textModelo"
                                            name="textModelo"
                                            classNameInput={"input-type-label form-control"}
                                            style={{ marginTop: 10 }}
                                            value={prVehi.categoriaNombre || categoriaNombre}
                                            onBlur={() => { }}
                                            validationCallback={res => this.setState({ hasModeloError: res, validate: false })}
                                            validationOption={{
                                                name: "textModelo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            }}
                                        />
                                    }

                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} />
                                <Col md={8}>
                                    {(`${categoriaCodigo}` === '-1') && <Alert color='warning'>{this.props.mensaje}</Alert>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className="mt-3" >

                                    <Button className="btn btn-detail-gray" onClick={() => this.props.handleBack()} style={{ display: "block", margin: '0px auto 0px 0px', }} >
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"   REGRESAR"}
                                    </Button>
                                </Col>
                                <Col md={6} className="mt-3" >

                                    <Button
                                        disabled={(`${categoriaCodigo}` === '-1')}
                                        className="btn btn-primary "
                                        style={{ display: 'block', margin: '0 0 0 auto', }}
                                        onClick={() => { this.onClick() }}>
                                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />{` CONTINUAR`}
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
            </LoadingScreen >

        )
    }
}
